<template>
	<inertia-head title="Abandoned Tracker" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Abandoned Tracker</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Welcome to TRC Admin Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-lg-12">
				<div class="block">
					<div class="block-header border-bottom">
						<h3 class="block-title">Request Record (list group by email)</h3>
					</div>
					<div class="block-content block-content-full">
						<div class="table-responsive">
							<table class="table table-striped table-borderless table-vcenter">
								<thead class="border-bottom">
									<tr>
										<th>Recent Request</th>
										<th>Request</th>
										<th>Abandoned</th>
										<th>Success</th>
										<th>Pending</th>
										<th>Email</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="requestRecord in requestRecords.data"
										:key="requestRecord.email"
									>
										<td>{{ requestRecord.recent_request }}</td>
										<td>
											<button
												@click="fetchTxnRecords(requestRecord.email)"
												type="button"
												class="btn btn-alt-primary btn-sm"
											>
												{{ `${requestRecord.request} Request` }}
											</button>
										</td>
										<td>{{ requestRecord.abandoned }}</td>
										<td>{{ requestRecord.success }}</td>
										<td>{{ requestRecord.pending }}</td>
										<td class="fs-sm">{{ requestRecord.email }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<pagination :collections="requestRecords" />
					</div>
				</div>
			</div>
			<div class="col-lg-12">
				<div class="block">
					<div class="block-header border-bottom">
						<h3 class="block-title">Follow-Up Record</h3>
					</div>
					<div class="block-content block-content-full"></div>
				</div>
			</div>
		</div>
	</div>
	<Transactions
		ref="txnsModal"
		:txnRecords="txnRecords"
		@fetchTxnRequest="fetchTxnRequest"
	/>
	<FollowUp ref="followUpModal" :txnRequest="txnRequest" />
</template>

<script>
import AuthLayout from '../../../Layouts/AuthLayout'
export default { layout: AuthLayout }
</script>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import { onMounted, ref } from 'vue'
import FollowUp from '../../../Components/Admin/AbandonedTracker/FollowUp'
import Transactions from '../../../Components/Admin/AbandonedTracker/Transations'

onMounted(() => {
	const pageContainer = document.getElementById('page-container')
	if (pageContainer.classList.contains('sidebar-o-xs'))
		pageContainer.classList.remove('sidebar-o-xs')
})

defineProps({
	requestRecords: Object,
	txnRecords: Object,
	txnRequest: Object,
})

const txnsModal = ref(null)

const followUpModal = ref(null)

const fetchTxnRecords = (email, action = 'txn_records') => {
	Inertia.get(
		route('admin.transactions.abandoned-tracker'),
		{
			email: email,
			action: action,
		},
		{
			preserveState: true,
			preserveScroll: true,
			only: ['requestRecords', 'txnRecords', 'txnRequest'],
			onSuccess: () => {
				txnsModal.value.toggleModal()
			},
		}
	)
}

const fetchTxnRequest = (counter, action = 'txn_request') => {
	Inertia.get(
		route('admin.transactions.abandoned-tracker'),
		{
			counter: counter,
			action: action,
		},
		{
			preserveState: true,
			preserveScroll: true,
			only: ['requestRecords', 'txnRecords', 'txnRequest'],
			onSuccess: () => {
				txnsModal.value.toggleModal()
				followUpModal.value.toggleModal()
			},
		}
	)
}
</script>
